const my_profile = {
  viewMyClubSeacretProfile: "Tingnan ang Aking Profile sa ClubSeacret", // translated 
  viewMoreDetails: "Tingnan ang Higit Pang Mga Detalye", // translated 
  verifiedEmail: "Na-verify na Email", // translated 
  unverifiedEmail: "Hindi Na-verify na Email", // translated 
  balance: "Balanse", // translated 
  pointsIn: "Mga Puntos Papasok", // translated 
  pointsOut: "Mga Puntos", // translated 
  topUp: "Mag-top up", // translated 
  pointsHistoryTable: "Talahanayan ng Kasaysayan ng mga Puntos", // translated 
  createdFrom: "Nilikha Mula sa", // translated 
  createdTo: "Nilikha Para", // translated 
  selectStatus: "Pumili ng katayuan...", // translated 
  searchByTitle: "Maghanap ayon sa pamagat...", // translated 
  offerStatus: "Katayuan ng Alok", // translated 
  selectOfferStatus: "Lahat", // translated 
  quotationSent: "Naipadala na ang Sipi", // translated 
  offerInProgress: "Alok na Isinasagawa", // translated 
  offerAvailable: "Alok na Magagamit", // translated 
  offerAccepted: "Tinanggap ang Alok", // translated 
  offerExpired: "Nag-expire na ang alok", // translated 
  offerReference: "Sanggunian ng Alok", // translated 
  tripStartDate: "Petsa ng Pagsisimula ng Biyahe", // translated 
  dueDate: "Takdang Petsa", // translated 
  viewOffer: "Tingnan ang Alok", // translated 
  notApplicable: "Wala", // translated 
  manageSubscription: "Pamahalaan ang Suskrisyon", // translated 
  logoAndColors: "Logo at mga Kulay", // translated 
  editColors: "I-edit ang mga Kulay", // translated 
  editLogo: "I-edit ang Logo", // translated 
  primaryColor: "Pangunahing Kulay", // translated 
  secondaryColor: "Pangalawang Kulay", // translated 
  subagentLogoAlt: "Logo ng Subagent", // translated 
  pickColors: "Pumili ng mga Kulay", // translated 
  logoPreview: "Preview ng Logo", // translated 
  logoPreviewAlt: "Paunang pagsilip ng logo", // translated 
  noLogoSelected: "Walang napiling logo", // translated 
  changeLogo: "Baguhin ang Logo", // translated 
  uploadLogo: "Mag-upload ng Logo", // translated 
  supportedImageFormats: "Mga sinusuportahang format: JPG, PNG. Pinakamataas na laki: 2MB", // translated 
  saving: "Nagse-save...", // translated 
  logoUpdatedSuccess: "Matagumpay na na-update ang logo", // translated 
  failedToUpdateLogo: "Nabigong i-update ang logo", // translated 
  colorsUpdatedSuccess: "Matagumpay na na-update ang mga kulay", // translated 
  failedToUpdateColors: "Nabigong i-update ang mga kulay", // translated 
  selectImageFile: "Mangyaring pumili ng file ng larawan", // translated 
  imageSizeLimit: "Ang laki ng larawan ay dapat na mas mababa sa 5MB", // translated 
  pushNotifications: "Mga Push Notification", // translated 
  pushNotificationsDescription: "Tumanggap ng mga abiso sa browser para sa mahahalagang update at kaganapan", // translated 
  pushNotificationsNotSupported: "Hindi sinusuportahan ang mga push notification sa browser na ito", // translated 
  pushNotificationsDeniedMessage: "Tinanggihan ang pahintulot sa notification. Paki-enable ang mga notification sa mga setting ng iyong browser para makatanggap ng mga push notification.", // translated 
  pushNotificationsEnabled: "Matagumpay na na-enable ang mga push notification", // translated 
  pushNotificationsDisabled: "Matagumpay na na-disable ang mga push notification", // translated 
  userInformationMissing: "Kulang ang impormasyon ng gumagamit", // translated 
  failedToUpdatePushNotifications: "Nabigong i-update ang mga setting ng push notification", // translated 
  notificationPermissionDenied: "Tinanggihan ang pahintulot sa notification. Paki-enable ito sa mga setting ng iyong browser.", // translated 
  notificationPermissionRequired: "Kinakailangan ang pahintulot sa notification para paganahin ang mga push notification", // translated 
  notSupported: "Hindi sinusuportahan", // translated 
  permissionDenied: "Tinanggihan ang pahintulot", // translated 
  permissionNotRequested: "Hindi hiniling ang pahintulot", // translated 
  enabled: "Pinagana", // translated 
  disabled: "May kapansanan", // translated 
};


export default my_profile;
